import styled from '@emotion/styled';

export const Container = styled.main`
	display: flex;
	flex-direction: column;
	gap: 8rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0;
	@media screen and (max-width: 900px) {
		padding: 8rem 2rem;
	}
`;
export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
`;
export const ContentItems = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
	width: 100%;
	margin: 0 auto;
`;
export const ContentTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	a {
		color: #00377b;
		text-decoration: underline;
		font-size: ${(props) => props.theme.fontSize.sizeMd};
		font-weight: ${(props) => props.theme.fontWeight.weightRegular};
		line-height: 140%;
		letter-spacing: -0.6px;
		margin-left: 1rem;
	}
`;
export const Table = styled.div`
	display: grid;
	grid-auto-rows: minmax(40px, auto);
	white-space: nowrap;
	overflow: auto;
	gap: 0.2rem;
	&.table1 {
		grid-template-columns: 1fr 1fr 2fr;
		.item1 {
			grid-column-start: 1;
			grid-column-end: 3;
		}
		.item2 {
			grid-row-start: 2;
			grid-row-end: 6;
		}
	}
	&.table2 {
		grid-template-columns: 1fr 1fr 1fr 1fr;
		grid-template-areas:
			'item1 item2 item3 item4'
			'item5 item6 item7 item8';
		@media screen and (max-width: 900px) {
			grid-template-columns: 1fr 4fr;
			grid-template-areas:
				'item1 item5'
				'item2 item6'
				'item3 item7'
				'item4 item8';
		}
	}
`;

export const TableHeadCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #00377b;
	color: white;
	padding: 10px 15px;
	text-align: left;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	line-height: 150%;
	&.center {
		justify-content: center;
	}
`;

export const TableCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #f1f3f5;
	padding: 2rem 1.6rem;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #212529;
	&.point {
		color: #12539e;
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
	&.center {
		justify-content: center;
		text-align: center;
	}
	&.min-height {
		min-height: 5.2rem;
	}
`;

export const TableCellLayout = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	gap: 1.2rem;
`;

export const ContentListLayout = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: start;
	align-items: start;
	gap: 0.4rem;
`;

export const ContentTitleSub = styled.p`
	color: #212529;
	font-size: 1.8rem;
	font-style: normal;
	font-weight: 600;
	line-height: 130%;
	letter-spacing: -0.6px;
`;

export const ContentDescription = styled.p`
	color: var(--Colors-Font---color-font-darker, #212529);
	font-size: 1.8rem;
	font-style: normal;
	font-weight: 400;
	line-height: 140%;
	letter-spacing: -0.6px;
`;

export const Button = styled.button`
	width: 100%;
	padding: 1rem 1.2rem;
	border: 1px solid ${(props) => props.theme.colors.primary400};
	background-color: #fff;
	color: ${(props) => props.theme.colors.primary400};
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	cursor: pointer;
`;
